import React, { FC, useEffect, useState } from 'react';
import classnames from 'classnames';
import s from './index.module.scss';
import CardNumber from './components/cardNumber';
import FormItem from './components/formItem';
import CardExpire from './components/cardExpire';
import CardCvc from './components/cardCvc';
import EmailField from './components/emailField';
import GetMyPlanBlock from '../getPlanButton/GetPlanButton';
import locales from '../../../../../../../../content.json';
import aes from 'crypto-js/aes';
import enc from 'crypto-js/enc-utf8';
import { IStripeViewModel } from '../../viewModel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../../store';

type Props = {
  className?: string;
  onCardCompleted?: (value: boolean, email: string) => void;
  cardEmail: string;
  viewModel: IStripeViewModel;
  disabled: boolean;
  setError: any;
};

const PaymentCard: FC<Props> = props => {
  const defaultEmail = useSelector((state: RootState) => state.navigation.purchaseFlowScreen.email  ?? '');
  const { className, onCardCompleted, cardEmail, viewModel, disabled, setError } = props;
  const [numberComplete, setNumberComplete] = useState(false);
  const [expireComplete, setExpireComplete] = useState(false);
  const [cvcComplete, setCvcComplete] = useState(false);
  const [email, setEmail] = useState({ value: '', isValid: false });

  useEffect(() => {
    if(defaultEmail) {
      setEmail({
        value: defaultEmail,
        isValid: true
      })
    }
  }, [])

  useEffect(() => {
    onCardCompleted(numberComplete && expireComplete && cvcComplete && email.isValid, email.value);
  }, [numberComplete, expireComplete, cvcComplete, email]);

  return (
    <div className={classnames(s.paymentCard, className)}>
      <FormItem>
        <CardNumber onChange={e => setNumberComplete(e.complete)} />
      </FormItem>
      <div className={s.row}>
        <FormItem>
          <CardExpire onChange={e => setExpireComplete(e.complete)} />
        </FormItem>
        <FormItem>
          <CardCvc onChange={e => setCvcComplete(e.complete)} />
        </FormItem>
      </div>
      <FormItem>
        <EmailField defaultValue={defaultEmail} onChange={(event, isValid) => setEmail({ value: event.target.value, isValid })} />
      </FormItem>
      <div className={s.buttonWrapper}>
        <GetMyPlanBlock email={cardEmail} viewModel={viewModel} disabled={disabled} setError={setError}/>
      </div>
    </div>
  );
};

export default PaymentCard;
